import {createApp} from 'vue'
import {createPinia} from 'pinia'
import App from './App.vue'
import * as Sentry from "@sentry/vue";

export const initApp = () => {
    const el = document.getElementById('js-nav-search');
    if (!el){
        return;
    }
    const pinia = createPinia();
    const app = createApp(App);
    app.use(pinia);
    Sentry.addIntegration(Sentry.vueIntegration({ app }));
    app.mount(el);
}
